import { render, staticRenderFns } from "./GuangzhouMobileElm39.vue?vue&type=template&id=06ae11c8&scoped=true"
import script from "./GuangzhouMobileElm39.vue?vue&type=script&lang=js"
export * from "./GuangzhouMobileElm39.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouMobileElm39.vue?vue&type=style&index=0&id=06ae11c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae11c8",
  null
  
)

export default component.exports